export const REALM_CODE = {
  EU: 'eu',
  US: 'us',
  SG: 'sg',
  CN360: 'cn360',
};

export const CROSSREALM_SETTINGS = {
  [REALM_CODE.EU]: {
    lawDocumentsUrl: 'https://legal.eu.wargaming.net/',
    isImmediateDeliveryValidation: true,
    showPegi: true,
  },
  [REALM_CODE.SG]: {
    lawDocumentsUrl: 'https://legal.asia.wargaming.net/',
    isImmediateDeliveryValidation: false,
    showPegi: false,
  },
  [REALM_CODE.US]: {
    lawDocumentsUrl: 'https://legal.na.wargaming.net/',
    isImmediateDeliveryValidation: false,
    showPegi: false,
  },
  [REALM_CODE.CN360]: {
    lawDocumentsUrl: 'https://wg.360.cn/610636235/610636240/610636283.html',
    isImmediateDeliveryValidation: false,
    showPegi: false,
  },
};
